import { trim } from "lodash";
import { useId, useMemo } from "react";

export type UseIdentifiersProps = { prefix?: string; suffix?: string };

export function useIdentifier({ prefix = "", suffix = "" }: UseIdentifiersProps) {
  const id = useId();
  return useMemo(() => [prefix, id, suffix].filter(trim).join("-"), [id, prefix, suffix]);
}
